import { createIcon } from "@chakra-ui/react";

export const EyeOpen = createIcon({
  displayName: "EyeOpen",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M12 3.602c-3.03 0-5.456 1.38-7.222 3.022-1.755 1.631-2.929 3.578-3.488 4.916a1.193 1.193 0 0 0 0 .923c.559 1.339 1.733 3.289 3.488 4.916C6.544 19.018 8.97 20.402 12 20.402c3.03 0 5.456-1.38 7.223-3.023 1.755-1.631 2.928-3.577 3.487-4.916a1.192 1.192 0 0 0 0-.923c-.559-1.338-1.732-3.288-3.487-4.916C17.456 4.985 15.03 3.602 12 3.602zm-5.4 8.4c0-2.982 2.419-5.4 5.4-5.4 2.982 0 5.4 2.418 5.4 5.4 0 2.98-2.418 5.4-5.4 5.4a5.401 5.401 0 0 1-5.4-5.4zm5.4-2.4a2.402 2.402 0 0 1-3.589 2.085 3.602 3.602 0 0 0 4.519 3.791 3.602 3.602 0 0 0-1.245-7.065c.199.349.315.754.315 1.189z"
      fill="#2B2C3D"
    />
  ],
  defaultProps: {
    "aria-label": "EyeOpen icon"
  }
});

export default EyeOpen;
